<app-nav *ngIf="!embedded" titulo="Servicios Contratados" descripcion="Configuración de rubros especiales (IKE, ABSA) por tipo de producto y zona.">
    <ng-container *ngTemplateOutlet="body"></ng-container>
</app-nav>
<ng-container *ngIf="embedded">
    <ng-container *ngTemplateOutlet="body"></ng-container>
</ng-container>

<ng-template #body>
    <div class="servicios-contratados" [class.embedded]="embedded">
        <div class="filter-row">
            <mat-button-toggle-group
                *ngIf="!embedded"
                class="tipo-toggle"
                [value]="tipoProductoActual"
                (change)="onTipoChange($event.value)">
                <mat-button-toggle value="VIVIENDA">Vivienda</mat-button-toggle>
                <mat-button-toggle value="COMERCIAL">Comercial</mat-button-toggle>
            </mat-button-toggle-group>

            <mat-form-field class="zona-selector garantor-form-field" appearance="outline">
                <mat-label>Zona</mat-label>
                <mat-select [value]="selectedZonaId" (selectionChange)="onZonaChange($event.value)">
                    <mat-option [value]="null">Default</mat-option>
                    <mat-option *ngFor="let z of zonas" [value]="z.id">{{ z.nombre }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <app-data-table
            [rows]="displayServicios"
            [columns]="columns"
            [paginatorStatus]="paginatorStatus"
            [externalPagination]="true"
            (updateRows)="updatePage($event)"
            (sortFn)="updateSort($event)"
        ></app-data-table>

        <button mat-raised-button class="garantor-button add-button" color="primary"
            routerLink="/configuracion/calculadora/servicios-contratados/nuevo">
            <mat-icon matPrefix>add</mat-icon>
            <span>Nuevo servicio</span>
        </button>
    </div>
</ng-template>

<ng-template #zonaColumnTemplate let-row="row">
    <span *ngIf="row.heredado" class="zona-heredado">
        <mat-icon class="heredado-icon">south</mat-icon>
        Heredado
    </span>
    <span *ngIf="!row.heredado && !row.idZona" class="zona-default">Default</span>
    <span *ngIf="!row.heredado && row.idZona">{{ getZonaLabel(row.idZona) }}</span>
</ng-template>

<ng-template #activoColumnTemplate let-row="row">
    <span [class]="row.activo ? 'status-badge active' : 'status-badge inactive'">
        {{ row.activo ? 'Activo' : 'Inactivo' }}
    </span>
</ng-template>

<ng-template #actionsColumnTemplate let-row="row">
    <div class="table-row-buttons">
        <ng-container *ngIf="!row.heredado">
            <button mat-icon-button matTooltip="Editar"
                [routerLink]="['/configuracion/calculadora/servicios-contratados', row.id, 'editar']">
                <mat-icon color="primary">edit</mat-icon>
            </button>
            <button mat-icon-button matTooltip="Volver al Default" (click)="revertirADefault(row)" *ngIf="row.idZona">
                <mat-icon>undo</mat-icon>
            </button>
            <button mat-icon-button matTooltip="Dar de baja" (click)="deleteServicio(row)" *ngIf="!row.idZona">
                <mat-icon color="accent">delete</mat-icon>
            </button>
        </ng-container>
    </div>
</ng-template>
